import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { useLoggedOutContactUsContextStore } from "../hooks/LoggedOutContactUsContextStore";
import { useLoggedOutContactUsNavigation } from "../hooks/useLoggedOutContactUsNavigation";
import { useLoggedOutExperience } from "../hooks/useLoggedOutExperience";
import { useLoggedOutHelpCenterArticle } from "../hooks/useLoggedOutHelpCenterArticle";
import { useLoggedOutIssueType } from "../hooks/useLoggedOutIssueType";

import { Blurb } from "./Blurb";
import { ConditionalStepper } from "./ConditionalStepper";
import { Csat } from "./Csat";
import { useFilteredArticles } from "./hooks/useFilteredArticles";
import { SuggestedArticle } from "./SuggestedArticle";

export const ArticleLinksView: React.FC = () => {
  const { helpCenterArticles } = useLoggedOutHelpCenterArticle();
  const { issueType } = useLoggedOutIssueType();
  const { setFeedbackCollected, feedbackCollectedByIssueType } =
    useLoggedOutContactUsNavigation();
  const [{ issueL2, issueL3 }] = useLoggedOutContactUsContextStore([
    "issueL2",
    "issueL3",
  ]);
  const { isLoggedOutUserExperience } = useLoggedOutExperience();
  const filteredArticles = useFilteredArticles(
    helpCenterArticles,
    issueL2,
    isLoggedOutUserExperience
  );

  return (
    <Column justify="flex-start">
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          defaultMessage="Does this help?"
          description={{
            text: "Title of showing help center article links",
            img: "https://cdn.faire.com/fastly/1d4b202d7b70e7f715312548a8834f7ee9ecffb02846ff973d14576110f3ee02.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <Blurb
        issueL3={issueL3}
        loggedOutExperience={isLoggedOutUserExperience}
      />
      <Wrapper>
        {filteredArticles.map((article, index) => (
          <React.Fragment key={article.id}>
            <SuggestedArticle {...article} />
            <ConditionalStepper
              length={filteredArticles.length}
              index={index}
            />
          </React.Fragment>
        ))}
        <Csat
          feedbackCollectedByIssueType={feedbackCollectedByIssueType}
          issueType={issueType}
          setFeedbackCollected={setFeedbackCollected}
        />
      </Wrapper>
      <Spacer height="3x" />
    </Column>
  );
};

const Wrapper = styled(Column)`
  padding: 24px 18px;
  border: 1px solid ${Core.border.muted};
  overflow-y: auto;
  max-height: 430px;
`;
